import React, { PropsWithChildren } from 'react';
import { graphql, useFragment } from 'react-relay';
import { matchPath, useLocation } from 'react-router-dom';
import { backofficeUrl } from 'src/shared/helpers';
import routes from 'src/shared/routes';
import { useAppState } from '../shared/appState';
import { appSubscriptionCheck$key } from './__generated__/appSubscriptionCheck.graphql';

function _RequireSubscriptionCheck({ children }: PropsWithChildren<{}>) {
    const { queryData } = useAppState();

    const { subscription, isAdminUser } = useFragment<appSubscriptionCheck$key>(
        graphql`
            fragment appSubscriptionCheck on Query {
                isAdminUser
                subscription {
                    isCancelled
                }
            }
        `,
        queryData!
    );

    if (isAdminUser) return null;

    if (!subscription || subscription.isCancelled) {
        const location = useLocation();
        const searchParams = new URLSearchParams(location.search);
        const error = searchParams.get('error');

        const redirectPath = '/seller/overviewsubscription';
        const redirectUrl = backofficeUrl(error ? `${redirectPath}?error=${encodeURIComponent(error)}` : redirectPath);

        window.location.href = redirectUrl;
    }

    return <>{children}</>;
}

function AppSubscriptionCheck({ children }: PropsWithChildren<{}>) {
    const location = useLocation();
    const currentRoute = routes.find((x) => {
        const mathWithParams = matchPath(x.url.replaceAll('?', ''), location.pathname);

        // Remove all optioanl params from x.url
        const urlWithNoOptionalParams = x.url.replace(/:\w+\?/g, '');

        const matchNoParams = matchPath(urlWithNoOptionalParams, location.pathname + '/');

        return matchNoParams || mathWithParams;
    });
    const isSubscriptionRequested = currentRoute?.isSubscriptionRequested ?? true;

    if (!isSubscriptionRequested) {
        return children;
    }

    return <_RequireSubscriptionCheck>{children}</_RequireSubscriptionCheck>;
}

export default AppSubscriptionCheck;
